import { useState, useEffect } from 'react';
import Loader from "../../components/Loader";
import API from '../../utils/API';
import Swal from 'sweetalert2';
import SegmentedControl from '../../components/SegmentedControl';
import UtilityBillAccount from '../../components/UtilityBillAccount';
import UtilityBillLine from '../../components/UtilityBillLine';
import GlobalSVG from '../../utils/GlobalSVG';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment'
import GlobalFuncs from '../../utils/GlobalFuncs';

const UtilityBillUploadHistory = (props) => {

    const [utilities, setUtilities] = useState()
    const [filteredUtilities, setFilteredUtilities] = useState()
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [showDateRange, setShowDateRange] = useState(false)
    const [downloadRange, setDownloadRange] = useState(false)
    const [gasUnit, setGasUnit] = useState('m3')
    const [waterUnit, setWaterUnit] = useState('l')
    const [bills, setBills] = useState([])
    const [loading, setLoading] = useState(false)
    const [tab, setTab] = useState(0)

    useEffect(() => {
        if (!props.building) return

        const cancelToken = API.cancelToken();
        setLoading(true)

        API.getUtilityBills(cancelToken, props.building).then(res => {
            setUtilities(res.data)
            return
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            let message = 'Please try again later.'
            if (err.response && err.response.data && err.response.data.includes('error')) {
                message = err.response.data.error
            }
            Swal.fire({
                title: 'Error.',
                text: message,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        }).finally(f => {
            setLoading(false)
        })

        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.building])

    useEffect(() => {
        if (!utilities) return
        let newList = utilities.filter(e => e.type === tab || e.id === null)
        setFilteredUtilities(newList)
    }, [utilities, tab, props.building])

    useEffect(() => {
        if (!filteredUtilities) return
        let tempAccount = filteredUtilities.filter(e => e.id === selectedAccount)
        setBills(tempAccount[0] ? tempAccount[0].bills : [])
    }, [selectedAccount, filteredUtilities])

    useEffect(() => {
        if (!downloadRange || !bills.length) return;

        const start = moment(downloadRange[0]).date(1)
        const end = moment(downloadRange[1]).endOf("month")


        const filtered = bills.filter(b => moment(`${b.bill_year}-${b.bill_month}-1`).isBetween(start, end))
        let tempExcel = filtered.map(b => ({
            "Basic Monthly": b.basic_monthly,
            "Bill ID": b.bill_id,
            "Bill Month": b.bill_month,
            "Bill Year": b.bill_year,
            "Electricity (kWh)": b.kwh_consumption,
            "Electricity (kVA)": b.kva_consumption,
            "Water": b.water_consumption,
            "Gas": b.gas_consumption,
            "Savings": b.basic_monthly,
            "Emissions": b.emissions,
            "Carbon Charge": b.carbon_charge,
            "Delivery Charges": b.delivery_charges,
            "GST": b.gst_cost,
            "Municipal Tax": b.municipal_tax,
            "Other Charges": b.other_charges,
            "PST": b.pst_cost,
            "KVA Cost": b.kva_cost,
            "KWH Cost": b.kwh_cost,
            "Water Cost": b.water_cost,
            "Gas Cost": b.gas_cost,
            "Sewage Consumption": b.sewage_consumption,
            "Sewage Cost": b.sewage_cost,
            "Created At": b.created_at,
            "Updated At": b.updated_at,
            "Created By": b.created_by,
            "Updated By": b.updated_by
        }))
        let account = filteredUtilities.find(a => selectedAccount && selectedAccount === a.id)
        GlobalFuncs.downloadExcel(tempExcel, account ? account.account_id : "Account", "Bills")
    }, [downloadRange, bills, selectedAccount, filteredUtilities]);


    return (
        <div className='tablet:py-8 mobile:py-3 min-h-[80vh] w-full'>
            <p className='text-2xl my-6'>Upload History</p>
            <SegmentedControl onChange={setTab} segments={['Electrical', 'Natural Gas', 'Water']} defaultSelected={tab} />
            <div className='w-full'>

                {
                    loading &&
                    <Loader />
                }
                <div className='tablet:p-8 mobile:p-3 min-h-[80vh] w-full'>
                    <p className='text-2xl my-6'>Accounts</p>
                    <div className="flex flex-nowrap items-center justify-start gap-8 overflow-auto w-full py-6">
                        {
                            filteredUtilities && filteredUtilities.map((u, i) => (
                                <UtilityBillAccount key={i + "utilitiyaccount"} item={u} select={setSelectedAccount} selected={selectedAccount && selectedAccount === u.id} setUtilities={setUtilities} readOnly={true} />
                            ))
                        }
                    </div>

                    {
                        <div className='mt-6'>
                            <div className="flex flex-nowrap items-center justify-between w-full">
                                <p className='text-2xl my-6 w-content'>Uploaded Bills</p>
                                {!showDateRange && bills.length !== 0 && <div onClick={() => setShowDateRange(true)} className="w-content flex flex-nowrap items-center justify-center">
                                    {GlobalSVG.download()}
                                    <p className='text-[#007b4e] tablet:text-[16px] mobile:text-[12px] font-medium cursor-pointer ml-2 mr-6'>Download</p>
                                </div>}
                                {
                                    showDateRange &&
                                    <div className='w-[200px] rounded-md border border-[#007b4e] px-2'>
                                        <DateRangePickerComponent
                                            className='p-2'
                                            onChange={(event) => setDownloadRange(event.value)} />
                                    </div>
                                }
                            </div>
                            <div className='mt-6 max-h-[400px] overflow-auto'>
                                {
                                    bills && bills.map((e, index) => (
                                        <UtilityBillLine 
                                            key={index + "utilitybill"} 
                                            value={e} 
                                            setUtilities={setUtilities} 
                                            type={tab}
                                            gasUnit={gasUnit}
                                            setGasUnit={(e)=>setGasUnit(e.target.value)}
                                            waterUnit={waterUnit}
                                            setWaterUnit={(e)=>setWaterUnit(e.target.value)} />
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default UtilityBillUploadHistory;